var module = angular.module('octopusApp.projects');

module.run(function(pluginRegistry) {

  pluginRegistry.registerFeature("Octopus.Features.CustomDirectory", function(busy, octopusRepository) {
    return {
      title: "Custom installation directory",
      description: "Change where Tentacle extracts your package",
      editTemplateUrl: "areas/projects/features/Octopus.Features.CustomDirectory_edit.html",
      priority: 5,
      editLink: function($scope, element) {
      },
      enable: function(action, step) {
      },
      disable: function(action, step) {
        delete action.Properties["Octopus.Action.Package.CustomInstallationDirectory"];
      }
    };
  });

});




//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/features/Octopus.Features.CustomDirectory.js
// module id = 558
// module chunks = 1